export const IS_PROD =
  window.env.VITE_ENV === 'prod-master' ||
  window.env.VITE_ENV === 'prod-eu' ||
  window.env.VITE_ENV === 'prod-india';
